import { TRANSFER_STATES } from 'services/search';
import { messages } from 'common';

export const TRANSFER_STATE_MUTLISELECT_OPTIONS = [
  ...Object.keys(TRANSFER_STATES).map((key) => (({
    value: TRANSFER_STATES[key],
    label: messages[key].defaultMessage,
  }))),
];



// WEBPACK FOOTER //
// ./src/components/SearchForm/constants.js